import { MonitoringErrorHandler } from 'monitoring-error-handler';
export class ExceptionHandlerFactory {
    static $inject = ['$log', '$injector'];
    constructor($log, $injector) {
        'ngInject';
        return (exception) => {
            const { application } = $injector.get('$rootScope');
            const $state = $injector.get('$state');
            const properties = () => application
                ? {
                    shortName: application.shortName,
                    name: application.name,
                    template: application.template,
                }
                : undefined;
            MonitoringErrorHandler.instance.trackException({
                exception,
                handledAt: $state.current.name,
                properties: properties(),
            });
            $log.error(exception);
        };
    }
}
